export default __webpack_public_path__ + "static/media/upgradeImage.0d2bdbf8.svg";